export default __webpack_public_path__ + "static/media/logout_icon.daa7f332.svg";